"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEEFO_POPUP_SCRIPT_ID = exports.ALL_LANGUAGES_REVIEWS_KEY = void 0;
exports.ALL_LANGUAGES_REVIEWS_KEY = 'all';
exports.FEEFO_POPUP_SCRIPT_ID = 'feefo-popup-script';
